// src/modules/app-views/_apps/appmulti/leads/pages/Init/components/LeadsPreviewActions/index.jsx
import { Button, Divider, Dropdown, Flex } from 'antd';
import { ContainerOutlined, EditOutlined, MoreOutlined, RestOutlined } from '@ant-design/icons';
import { PiLifebuoy } from 'react-icons/pi';
import translateX from 'utils/translateX';

const dividerStyle = { margin: '16px 0' };

const LeadsPreviewActions = props => {
  const {
    selectedDocument,
    handleEditDocument,
    handleArchiveDocuments,
    handleRemoveDocuments,
    handleRestoreDocuments,
    setShow,
    folder,
    refresh,
  } = props;

  if (!selectedDocument) return null;

  const isArchiveOrRecycle = folder === 'archive' || folder === 'recycle';
  const isRecycle = folder === 'recycle';

  const handleClose = () => setShow?.(false);

  const handleOpen = () => {
    handleClose();
    setTimeout(() => handleEditDocument?.(selectedDocument), 100);
  };

  const handleArchive = () =>
    handleArchiveDocuments?.([selectedDocument], {
      onSuccess: () => {
        handleClose();
        refresh?.();
      },
    });

  const handleRemove = () =>
    handleRemoveDocuments?.([selectedDocument], {
      onSuccess: () => {
        handleClose();
        refresh?.();
      },
    });

  const handleRestore = () =>
    handleRestoreDocuments?.([selectedDocument], {
      onSuccess: () => {
        handleClose();
        refresh?.();
      },
    });

  const primaryActions = [];
  const secondaryActions = [];

  if (isArchiveOrRecycle) {
    primaryActions.push({
      key: 'restore',
      label: translateX('restore'),
      icon: <PiLifebuoy />,
      onClick: handleRestore,
    });
    primaryActions.push({
      key: 'remove',
      label: isRecycle ? translateX('permanently_remove') : translateX('remove'),
      icon: <RestOutlined />,
      onClick: handleRemove,
      danger: isRecycle,
    });
  } else {
    primaryActions.push({
      key: 'open',
      label: translateX('open'),
      icon: <EditOutlined />,
      onClick: handleOpen,
      type: 'primary',
    });
    secondaryActions.push(
      {
        key: 'archive',
        label: translateX('archive'),
        icon: <ContainerOutlined />,
        onClick: handleArchive,
      },
      {
        key: 'remove',
        label: translateX('remove'),
        icon: <RestOutlined />,
        onClick: handleRemove,
        danger: true,
      }
    );
  }

  const menuItems = secondaryActions.map(a => ({
    key: a.key,
    icon: a.icon,
    label: a.label,
    danger: a.danger,
    onClick: a.onClick,
  }));

  return (
    <div>
      <Divider style={dividerStyle} />
      <Flex vertical gap={8} style={{ width: '100%' }}>
        {primaryActions.map(action => (
          <Button
            key={action.key}
            type={action.type || 'default'}
            icon={action.icon}
            onClick={action.onClick}
            danger={action.danger}
            block
          >
            {action.label}
          </Button>
        ))}
        {menuItems.length > 0 && (
          <Dropdown menu={{ items: menuItems }} trigger={['click']}>
            <Button icon={<MoreOutlined />} block>
              {translateX('more_actions')}
            </Button>
          </Dropdown>
        )}
      </Flex>
    </div>
  );
};

export default LeadsPreviewActions;
